/* =========================
   ASSET: store-hero.js
   ========================= */
   (() => {
  const root = document.querySelector('[data-store-carousel]');
  if (!root) return;

  const track = root.querySelector('[data-carousel-track]');
  const prev = root.querySelector('[data-carousel-prev]');
  const next = root.querySelector('[data-carousel-next]');
  if (!track || !prev || !next) return;

  const slides = Array.from(track.children);
  if (slides.length <= 1) return;

  const indexFromScroll = () => {
    const w = track.clientWidth || 1;
    return Math.round(track.scrollLeft / w);
  };

  const goTo = (idx) => {
    const w = track.clientWidth || 1;
    track.scrollTo({ left: idx * w, behavior: 'smooth' });
  };

  prev.addEventListener('click', () => goTo(Math.max(0, indexFromScroll() - 1)));
  next.addEventListener('click', () => goTo(Math.min(slides.length - 1, indexFromScroll() + 1)));

  window.addEventListener('resize', () => goTo(indexFromScroll()), { passive: true });
})();

(() => {
  const modal = document.querySelector('[data-store-hours-modal]');
  const openBtn = document.querySelector('[data-store-hours-open]');
  const closeBtns = document.querySelectorAll('[data-store-hours-close]');
  const standardList = document.querySelector('[data-store-hours-standard-list]');
  const exceptionSection = document.querySelector('[data-store-hours-exception-section]');
  const exceptionList = document.querySelector('[data-store-hours-exception-list]');
  const dataScript = document.querySelector('[id^="StoreHoursData-"]');

  if (!modal || !openBtn || !standardList || !dataScript) return;

  let hoursData = {};
  try {
    hoursData = JSON.parse(dataScript.textContent || '{}');
  } catch (e) {
    hoursData = {};
  }

  const weekdayOrder = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday'
  ];

// Libellés fournis par la section, dans la langue de la page. Les valeurs
  // ci-dessous ne servent que de secours si le bloc JSON est absent : sans ça,
  // ce fichier devrait exister en autant de versions qu'il y a de langues.
  let sectionLabels = {};
  try {
    const labelScript = document.querySelector('[id^="StoreHoursLabels-"]');
    if (labelScript) sectionLabels = JSON.parse(labelScript.textContent || '{}');
  } catch (e) {
    sectionLabels = {};
  }

  const weekdayLabels = sectionLabels.weekdays || {
    sunday: 'Dimanche',
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi'
};

const closedLabel = sectionLabels.closed || 'Fermé';

  const monthLabels = sectionLabels.months || {
    1: 'janvier',
    2: 'février',
    3: 'mars',
    4: 'avril',
    5: 'mai',
    6: 'juin',
    7: 'juillet',
    8: 'août',
    9: 'septembre',
    10: 'octobre',
    11: 'novembre',
    12: 'décembre'
};

  const today = new Date();
  const todayWeekday = weekdayOrder[today.getDay()];
  const todayISO = [
    today.getFullYear(),
    String(today.getMonth() + 1).padStart(2, '0'),
    String(today.getDate()).padStart(2, '0')
  ].join('-');

  function escapeHtml(str) {
    return String(str || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function formatRanges(ranges) {
if (!Array.isArray(ranges) || !ranges.length) return closedLabel;
return ranges.map((r) => String(r).replace('-', ' - ')).join(' / ');
  }

function formatFrenchDate(isoDate) {
if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return isoDate || '';
    const [year, month, day] = isoDate.split('-');
    const d = new Date(Number(year), Number(month) - 1, Number(day));
    const weekday = weekdayLabels[weekdayOrder[d.getDay()]] || '';
    const monthLabel = monthLabels[Number(month)] || month;
return `${weekday} ${Number(day)} ${monthLabel}`;
}

  function buildStandardHours() {
    const standard = hoursData.standard || {};
    const orderedDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

    return orderedDays
      .map((day, index) => {
        const ranges = standard[day] || [];
        const isToday = day === todayWeekday;
        const isAlt = index % 2 === 0;

        return `
          <div class="gw-store-hours-modal__row${isToday ? ' is-today' : ''}${isAlt ? ' is-alt' : ''}">
            <div class="gw-store-hours-modal__day">${weekdayLabels[day] || day}</div>
            <div class="gw-store-hours-modal__value">${escapeHtml(formatRanges(ranges))}</div>
          </div>
        `;
      })
      .join('');
  }

  function normalizeExceptions() {
    const exceptional = Array.isArray(hoursData.exceptional) ? hoursData.exceptional : [];
    const specific = Array.isArray(hoursData.specific) ? hoursData.specific : [];

    return [...exceptional, ...specific]
      .filter((item) => {
        if (!item) return false;

        const startDate = item.startDate || '';
        const endDate = item.endDate || startDate || '';
        const hasDate = Boolean(startDate || endDate);

        if (!hasDate) return false;

        const hasRanges = Array.isArray(item.ranges) && item.ranges.length > 0;
        const isClosed = item.closed === true;

        if (!hasRanges && !isClosed) return false;

        return endDate >= todayISO;
      })
      .sort((a, b) => {
        const aDate = a.startDate || a.endDate || '';
        const bDate = b.startDate || b.endDate || '';
        return aDate.localeCompare(bDate);
      })
      .slice(0, 2);
  }

  function buildExceptionHours() {
    const items = normalizeExceptions();

    if (!items.length) {
      exceptionSection.hidden = true;
      return '';
    }

    exceptionSection.hidden = false;

    return items.map((item) => {
      const startDate = item.startDate || '';
      const endDate = item.endDate || '';
      const sameDay = startDate && endDate ? startDate === endDate : true;
      const label = sameDay
? formatFrenchDate(startDate || endDate)
        : `${formatFrenchDate(startDate)} au ${formatFrenchDate(endDate)}`;
const isClosed = item.closed === true || !Array.isArray(item.ranges) || !item.ranges.length;
      const isToday =
        !!(startDate || endDate) &&
        todayISO >= (startDate || endDate) &&
        todayISO <= (endDate || startDate);

      return `
        <div class="gw-store-hours-modal__row gw-store-hours-modal__row--exception${isClosed ? ' is-closed' : ' is-open'}${isToday ? ' is-today' : ''}">
          <div class="gw-store-hours-modal__day">${escapeHtml(label)}</div>
<div class="gw-store-hours-modal__value">${escapeHtml(isClosed ? closedLabel : formatRanges(item.ranges))}</div>
</div>
      `;
    }).join('');
  }

  function renderHours() {
    standardList.innerHTML = buildStandardHours();
    if (exceptionList) {
      exceptionList.innerHTML = buildExceptionHours();
    }
  }

  function openModal() {
    renderHours();
    modal.hidden = false;
    document.documentElement.classList.add('gw-store-hours-lock');
    document.body.classList.add('gw-store-hours-lock');
  }

  function closeModal() {
    modal.hidden = true;
    document.documentElement.classList.remove('gw-store-hours-lock');
    document.body.classList.remove('gw-store-hours-lock');
  }

  openBtn.addEventListener('click', function (event) {
    event.preventDefault();
    openModal();
  });

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      closeModal();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
})();
/* =========================
   ASSET: services-audition.js
   ========================= */
(() => {
  const sections = Array.from(document.querySelectorAll('[data-gw-services]'));
  if (!sections.length) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const BASE_PCT = 8;

  const getGap = (track) => {
    const styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap || 0) || 0;
  };

  const getStep = (track) => {
    const card = track.querySelector('.gw-services__card');
    if (!card) return track.clientWidth || 1;

    return card.offsetWidth + getGap(track);
  };

  const update = (track, fill) => {
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (maxScroll <= 0) {
      fill.style.width = '0%';
      fill.setAttribute('aria-valuenow', '0');
      return;
    }

    const t = clamp(track.scrollLeft / maxScroll, 0, 1);
    const pct = BASE_PCT + t * (100 - BASE_PCT);
    const value = clamp(Math.round(pct), BASE_PCT, 100);

    fill.style.width = value + '%';
    fill.setAttribute('aria-valuenow', String(value));
  };

  const snapToNearest = (track) => {
    const step = getStep(track);
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (!step || maxScroll <= 0) return;

    const targetIndex = Math.round(track.scrollLeft / step);
    const targetLeft = clamp(targetIndex * step, 0, maxScroll);

    track.scrollTo({
      left: targetLeft,
      behavior: 'smooth'
    });
  };

  const bindOne = (section) => {
    const track = section.querySelector('[data-gw-services-track]');
    const fill = section.querySelector('[data-gw-services-progress-fill]');
    if (!track || !fill) return;

    let scrollTimer = null;
    let isPointerDown = false;

    const onScroll = () => {
      update(track, fill);

      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        if (!isPointerDown) {
          snapToNearest(track);
        }
      }, 90);
    };

    const onPointerDown = () => {
      isPointerDown = true;
      clearTimeout(scrollTimer);
    };

    const onPointerUp = () => {
      isPointerDown = false;

      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        snapToNearest(track);
      }, 80);
    };

    const onResize = () => {
      update(track, fill);
      snapToNearest(track);
    };

    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('pointerdown', onPointerDown, { passive: true });
    track.addEventListener('pointerup', onPointerUp, { passive: true });
    track.addEventListener('pointercancel', onPointerUp, { passive: true });
    track.addEventListener('touchend', onPointerUp, { passive: true });

    window.addEventListener('resize', onResize, { passive: true });

    update(track, fill);
  };

  sections.forEach(bindOne);
})();
/* =========================
   ASSET: team-carousel.js
   ========================= */
(() => {
  const sections = Array.from(document.querySelectorAll('[data-gw-team]'));
  if (!sections.length) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  const getGap = (track) => {
    const styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap || 0) || 0;
  };

  const bind = (section) => {
    const track = section.querySelector('[data-gw-team-track]');
    const prev = section.querySelector('[data-gw-team-prev]');
    const next = section.querySelector('[data-gw-team-next]');
    if (!track || !prev || !next) return;

    const slides = Array.from(track.querySelectorAll('[data-gw-team-slide]'));
    if (slides.length <= 1) return;

    const getStep = () => {
      const slide = slides[0];
      if (!slide) return track.clientWidth || 1;

      return slide.offsetWidth + getGap(track);
    };

    const getMaxScroll = () => {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    };

    const getIndex = () => {
      const step = getStep();
      if (!step) return 0;

      return Math.round(track.scrollLeft / step);
    };

    const updateNav = () => {
      const maxScroll = getMaxScroll();
      const currentScroll = track.scrollLeft;
      const tolerance = 4;

      const isAtStart = currentScroll <= tolerance;
      const isAtEnd = currentScroll >= maxScroll - tolerance;

      prev.classList.toggle('is-hidden', isAtStart);
      next.classList.toggle('is-hidden', isAtEnd || maxScroll <= tolerance);
    };

    const goTo = (idx, behavior = 'smooth') => {
      const step = getStep();
      const maxScroll = getMaxScroll();

      if (!step || maxScroll <= 0) {
        updateNav();
        return;
      }

      const targetLeft = clamp(idx * step, 0, maxScroll);

      track.scrollTo({
        left: targetLeft,
        behavior
      });

      window.requestAnimationFrame(updateNav);
    };

    const snapToNearest = () => {
      goTo(getIndex(), 'smooth');
    };

    let scrollTimer = null;
    let isPointerDown = false;

    prev.addEventListener('click', () => {
      goTo(Math.max(0, getIndex() - 1));
    });

    next.addEventListener('click', () => {
      goTo(Math.min(slides.length - 1, getIndex() + 1));
    });

    const onScroll = () => {
      window.requestAnimationFrame(updateNav);

      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        if (!isPointerDown) {
          snapToNearest();
        }
      }, 90);
    };

    const onPointerDown = () => {
      isPointerDown = true;
      clearTimeout(scrollTimer);
    };

    const onPointerUp = () => {
      isPointerDown = false;

      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        snapToNearest();
      }, 80);
    };

    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('pointerdown', onPointerDown, { passive: true });
    track.addEventListener('pointerup', onPointerUp, { passive: true });
    track.addEventListener('pointercancel', onPointerUp, { passive: true });
    track.addEventListener('touchend', onPointerUp, { passive: true });

    window.addEventListener('resize', () => {
      goTo(getIndex(), 'auto');
      window.requestAnimationFrame(updateNav);
    }, { passive: true });

    requestAnimationFrame(updateNav);
    setTimeout(updateNav, 150);
  };

  sections.forEach(bind);
})();
/* =========================
   ASSET: hearing-aid-types.js
   ========================= */
(() => {
  const sections = Array.from(document.querySelectorAll('[data-gw-aidtypes]'));
  if (!sections.length) return;

  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const BASE_PCT = 8;

  const getGap = (track) => {
    const styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap || 0) || 0;
  };

  const getStep = (track) => {
    const card =
      track.querySelector('[data-gw-aidtypes-card]') ||
      track.querySelector('.gw-aidtypes__card');

    if (!card) return track.clientWidth || 1;

    return card.offsetWidth + getGap(track);
  };

  const update = (track, fill) => {
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (maxScroll <= 0) {
      fill.style.width = '0%';
      fill.setAttribute('aria-valuenow', '0');
      return;
    }

    const t = clamp(track.scrollLeft / maxScroll, 0, 1);
    const pct = BASE_PCT + t * (100 - BASE_PCT);
    const value = clamp(Math.round(pct), BASE_PCT, 100);

    fill.style.width = value + '%';
    fill.setAttribute('aria-valuenow', String(value));
  };

  const snapToNearest = (track) => {
    const step = getStep(track);
    const maxScroll = track.scrollWidth - track.clientWidth;

    if (!step || maxScroll <= 0) return;

    const targetIndex = Math.round(track.scrollLeft / step);
    const targetLeft = clamp(targetIndex * step, 0, maxScroll);

    track.scrollTo({
      left: targetLeft,
      behavior: 'smooth'
    });
  };

  sections.forEach((section) => {
    const track = section.querySelector('[data-gw-aidtypes-track]');
    const fill = section.querySelector('[data-gw-aidtypes-progress-fill]');
    if (!track || !fill) return;

    let scrollTimer = null;
    let isPointerDown = false;

    const run = () => update(track, fill);

    const onScroll = () => {
      run();

      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        if (!isPointerDown) {
          snapToNearest(track);
          run();
        }
      }, 90);
    };

    const onPointerDown = () => {
      isPointerDown = true;
      clearTimeout(scrollTimer);
    };

    const onPointerUp = () => {
      isPointerDown = false;

      clearTimeout(scrollTimer);

      scrollTimer = setTimeout(() => {
        snapToNearest(track);
        run();
      }, 80);
    };

    const onResize = () => {
      run();
      snapToNearest(track);
    };

    track.addEventListener('scroll', onScroll, { passive: true });

    track.addEventListener('pointerdown', onPointerDown, { passive: true });
    track.addEventListener('pointerup', onPointerUp, { passive: true });
    track.addEventListener('pointercancel', onPointerUp, { passive: true });
    track.addEventListener('touchend', onPointerUp, { passive: true });

    window.addEventListener('resize', onResize, { passive: true });

    requestAnimationFrame(run);
    requestAnimationFrame(run);
    setTimeout(run, 150);
    window.addEventListener('load', run, { passive: true });

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => {
        run();
        snapToNearest(track);
      });

      ro.observe(track);
    }
  });
})();

/* avis-carousel.js */



(function () {
  const root = document.querySelector(".tv-section");
  if (!root) return;

  const storeCode = (root.dataset.storeCode || "").trim();

  const avgEl = root.querySelector("[data-average]");
  const countEl = root.querySelector("[data-count]");
  const starsEl = root.querySelector("[data-stars]");
  const trackEl = root.querySelector("[data-track]");
  const dotsEl = root.querySelector("[data-dots]");
  const errorEl = root.querySelector("[data-error]");

  const globalEndpoint = "https://storage.googleapis.com/trustville-widgets/shop/c/891/prod/widget_json_positive_feedbacks.json";
  const storeEndpoint = storeCode
    ? `https://storage.googleapis.com/trustville-widgets/shop/c/891/pc_code/${encodeURIComponent(storeCode)}/prod/widget_json_feedbacks.json`
    : null;

  let feedbacks = [];
  let currentIndex = 0;
  let maxIndex = 0;

  let autoplayTimer = null;
  const AUTOPLAY_MS = 4200;

  let isDragging = false;
  let dragStartX = 0;
  let dragStartTranslate = 0;
  let currentTranslate = 0;
  let suppressClickUntil = 0;

  init();

  function initFromDom() {
    if (!trackEl) return;
    feedbacks = Array.from(trackEl.querySelectorAll(".tv-card"));
    if (!feedbacks.length) return;
    computeBounds();
    renderDots();
    goTo(0, true);
    setupControls();
    window.addEventListener("resize", onResize, { passive: true });
  }

  function init() {
    if (root.dataset.tvStatic === "true") {
      initFromDom();
      return;
    }

    if (storeEndpoint) {
      fetchJson(storeEndpoint)
        .then((data) => {
          if (!isUsable(data)) throw new Error("Empty store data");
          applyData(data);
        })
        .catch((e) => {
          console.warn("Trustville store fetch error, fallback global:", e);

          fetchJson(globalEndpoint)
            .then((data) => {
              if (!isUsable(data)) throw new Error("Empty global data");
              applyData(data);
            })
            .catch((err) => {
              console.warn("Trustville global fetch error:", err);
              showError();
            });
        });
    } else {
      fetchJson(globalEndpoint)
        .then((data) => {
          if (!isUsable(data)) throw new Error("Empty global data");
          applyData(data);
        })
        .catch((e) => {
          console.warn("Trustville global fetch error:", e);
          showError();
        });
    }
  }

  function fetchJson(url) {
    return fetch(url, { cache: "no-store" }).then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.json();
    });
  }

  function isUsable(data) {
    if (!data || typeof data !== "object") return false;

    const hasAvg = typeof data.rating_average === "number" && !isNaN(data.rating_average);
    const hasCount = typeof data.rating_count === "number" && !isNaN(data.rating_count);
    const hasFeedbacks = Array.isArray(data.feedbacks) && data.feedbacks.length > 0;

    return hasAvg || hasCount || hasFeedbacks;
  }

  function applyData(data) {
    const ratingAverage = typeof data.rating_average === "number" ? data.rating_average : null;
    const ratingCount =
      typeof data.rating_count === "number"
        ? data.rating_count
        : Array.isArray(data.feedbacks) ? data.feedbacks.length : 0;

    if (avgEl) avgEl.textContent = ratingAverage !== null ? ratingAverage.toFixed(1).replace(".", ",") : "–";
    if (countEl) countEl.textContent = String(ratingCount);

    if (starsEl) {
      starsEl.innerHTML = renderStars(ratingAverage || 0);
      starsEl.setAttribute("aria-label", `Note moyenne ${((ratingAverage || 0)).toFixed(1).replace(".", ",")} sur 5`);
    }

    feedbacks = Array.isArray(data.feedbacks) ? data.feedbacks.slice() : [];
    feedbacks.sort((a, b) => (Date.parse(b?.created_at || "") || 0) - (Date.parse(a?.created_at || "") || 0));
    feedbacks = feedbacks.slice(0, 10);

    if (!feedbacks.length) {
      showError();
      return;
    }

    renderCards();
    computeBounds();
    renderDots();
    goTo(0, true);

    setupControls();
    window.addEventListener("resize", onResize, { passive: true });
  }

  function renderCards() {
    if (!trackEl) return;
    trackEl.innerHTML = feedbacks.map(renderCard).join("");
  }

  function computeBounds() {
    if (!trackEl) return;

    const visible = getVisible();
    const visibleCeil = Math.ceil(visible);

    maxIndex = Math.max(0, feedbacks.length - visibleCeil);

    if (currentIndex > maxIndex) currentIndex = maxIndex;
  }

  function renderDots() {
    if (!dotsEl) return;

    const total = maxIndex + 1;
    dotsEl.innerHTML = Array.from({ length: total }, (_, i) =>
      `<button class="tv-dot ${i === currentIndex ? "is-active" : ""}" type="button" aria-label="Position ${i + 1}" data-dot="${i}"></button>`
    ).join("");
  }

  function setupControls() {
    const slider = root.querySelector("[data-slider]");
    if (!slider) return;

    setupButtons(slider);
    setupDots();
    setupDrag(slider);

    startAutoplay();
  }

  function setupButtons(slider) {
    const prevBtn = slider.querySelector("[data-prev]");
    const nextBtn = slider.querySelector("[data-next]");

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        if (Date.now() < suppressClickUntil) return;
        const next = currentIndex <= 0 ? maxIndex : currentIndex - 1;
        goTo(next);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        if (Date.now() < suppressClickUntil) return;
        const next = currentIndex >= maxIndex ? 0 : currentIndex + 1;
        goTo(next);
      });
    }
  }

  function setupDots() {
    if (!dotsEl) return;

    dotsEl.addEventListener("click", (e) => {
      if (Date.now() < suppressClickUntil) return;
      const btn = e.target.closest("[data-dot]");
      if (!btn) return;
      const i = Number(btn.getAttribute("data-dot") || "0");
      goTo(i);
    });
  }

  function goTo(index, skipAnim) {
    if (!trackEl) return;

    currentIndex = clamp(index, 0, maxIndex);

    const step = getStep();
    if (!step) return;

    const target = -currentIndex * step;
    currentTranslate = target;

    if (skipAnim) trackEl.style.transition = "none";
    trackEl.style.transform = `translateX(${target}px)`;
    if (skipAnim) {
      requestAnimationFrame(() => {
        trackEl.style.transition = "transform 520ms ease";
      });
    }

    if (dotsEl) {
      dotsEl.querySelectorAll(".tv-dot").forEach((d, i) => d.classList.toggle("is-active", i === currentIndex));
    }
  }

  function onResize() {
    const prevMax = maxIndex;
    computeBounds();

    if (prevMax !== maxIndex) renderDots();
    goTo(currentIndex, true);
  }

  function startAutoplay() {
    stopAutoplay();
    if (maxIndex <= 0) return;

    autoplayTimer = window.setInterval(() => {
      if (isDragging) return;
      const next = currentIndex >= maxIndex ? 0 : currentIndex + 1;
      goTo(next);
    }, AUTOPLAY_MS);
  }

  function stopAutoplay() {
    if (!autoplayTimer) return;
    window.clearInterval(autoplayTimer);
    autoplayTimer = null;
  }

  function setupDrag(slider) {
    const wrap = slider.querySelector("[data-trackwrap]") || slider.querySelector(".tv-trackWrap");
    if (!wrap || !trackEl) return;

    wrap.style.touchAction = "pan-y";
    wrap.addEventListener("pointerdown", onPointerDown);

    window.addEventListener("pointermove", onPointerMove, { passive: false });
    window.addEventListener("pointerup", onPointerUp);
    window.addEventListener("pointercancel", onPointerUp);

    function onPointerDown(e) {
      if (maxIndex <= 0) return;

      isDragging = true;
      dragStartX = e.clientX;

      const m = (trackEl.style.transform || "").match(/translateX\(([-0-9.]+)px\)/);
      dragStartTranslate = m ? parseFloat(m[1]) : currentTranslate;

      trackEl.style.transition = "none";

      try { wrap.setPointerCapture(e.pointerId); } catch (_) {}
    }

    function onPointerMove(e) {
      if (!isDragging) return;

      const dx = e.clientX - dragStartX;

      if (Math.abs(dx) > 6) {
        suppressClickUntil = Date.now() + 350;
      }

      const minT = -maxIndex * (getStep() || 0);
      const maxT = 0;

      let nextT = dragStartTranslate + dx;

      const rubber = 0.35;
      if (nextT > maxT) nextT = maxT + (nextT - maxT) * rubber;
      if (nextT < minT) nextT = minT + (nextT - minT) * rubber;

      currentTranslate = nextT;
      trackEl.style.transform = `translateX(${nextT}px)`;

      e.preventDefault();
    }

    function onPointerUp(e) {
      if (!isDragging) return;
      isDragging = false;

      const step = getStep();
      if (!step) {
        trackEl.style.transition = "transform 520ms ease";
        goTo(currentIndex);
        return;
      }

      const rawIndex = Math.round(Math.abs(currentTranslate) / step);
      const snapped = clamp(rawIndex, 0, maxIndex);

      trackEl.style.transition = "transform 520ms ease";
      goTo(snapped);

      try { wrap.releasePointerCapture(e.pointerId); } catch (_) {}
    }
  }

  function getStep() {
    if (!trackEl) return 0;
    const firstCard = trackEl.querySelector(".tv-card");
    if (!firstCard) return 0;
    const gap = getGap(trackEl);
    const cardW = firstCard.getBoundingClientRect().width;
    return cardW + gap;
  }

  function getVisible() {
    return window.matchMedia("(max-width: 980px)").matches ? 1.12 : 3.5;
  }

  function getGap(el) {
    const cs = window.getComputedStyle(el);
    const g = cs.columnGap || cs.gap || "0px";
    const n = parseFloat(g);
    return Number.isFinite(n) ? n : 0;
  }

  function renderCard(fb) {
    const rating = typeof fb?.rating === "number" ? fb.rating : 0;
    const author = (fb?.author || fb?.display_name || "").trim() || "Client";
    const text = (fb?.verbatim || fb?.comment || "").trim() || "";
    const dateStr = formatDate(fb?.created_at);

    return `
      <article class="tv-card">
        <div class="tv-cardTop">
          <div class="tv-quote" aria-hidden="true">“</div>
          <div>
            <div class="tv-cardStars" aria-label="Note ${rating.toFixed(1)} sur 5">
              ${renderStars(rating)}
            </div>
            <p class="tv-text">${escapeHtml(text)}</p>
            <div class="tv-meta">
              <span class="tv-author">${escapeHtml(author)}</span>
              <span class="tv-date">${escapeHtml(dateStr)}</span>
            </div>
          </div>
        </div>
      </article>
    `;
  }

  function renderStars(value) {
    const v = Math.max(0, Math.min(5, Number(value) || 0));
    const full = Math.floor(v);
    const frac = v - full;
    const half = frac >= 0.25 && frac < 0.75 ? 1 : 0;
    const roundedFull = frac >= 0.75 ? full + 1 : full;
    const empty = 5 - roundedFull - half;

    const starSvg = () => `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 17.3l-6.18 3.25 1.18-6.9L1.99 8.9l6.92-1L12 1.6l3.09 6.3 6.92 1-5.01 4.75 1.18 6.9z"></path>
      </svg>
    `;

    const fullStars = Array.from({ length: roundedFull }).map(() =>
      `<span class="tv-star tv-star--full">${starSvg()}</span>`
    ).join("");

    const halfStar = half
      ? `<span class="tv-star tv-star--half">
           <span class="tv-starHalfBase tv-star tv-star--empty">${starSvg()}</span>
           <span class="tv-starHalfFill tv-star tv-star--full">${starSvg()}</span>
         </span>`
      : "";

    const emptyStars = Array.from({ length: empty }).map(() =>
      `<span class="tv-star tv-star--empty">${starSvg()}</span>`
    ).join("");

    return fullStars + halfStar + emptyStars;
  }

  function formatDate(iso) {
    const t = Date.parse(iso || "");
    if (!t) return "";
    const d = new Date(t);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = String(d.getFullYear());
    return `${dd}/${mm}/${yyyy}`;
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
  }

  function showError() {
    if (errorEl) errorEl.hidden = false;
    if (avgEl) avgEl.textContent = "–";
    if (countEl) countEl.textContent = "0";
    if (starsEl) starsEl.textContent = "";
  }
})();

/* Sur une page Maison, le bouton « prendre rendez-vous » de l'en-tête renvoie
   vers le module de RDV de la page plutôt que vers la page de prise de RDV.

   Repris du thème français, avec une condition en plus : on ne réécrit que si
   l'ancre existe réellement dans la page. Sans ça, le bouton pointerait dans le
   vide sur les marchés où le module v3 n'est pas déployé (Canada, UK), qui
   masquent ce bloc. Le test d'origine portait sur le chemin
   « /blogs/nos-boutiques/ », qui ne dit rien de la présence du module. */
document.addEventListener('DOMContentLoaded', () => {
  if (!document.getElementById('rendez-vous')) return;

  const rdvButton = document.querySelector(
    '.header__actions--buttons a[href*="prendre-rendez-vous-en-maison"]'
  );
  if (rdvButton) rdvButton.setAttribute('href', '#rendez-vous');
});
/* Le champ horaires (opening_hours_evermaps_do_not_touch) est du JSON
   structuré depuis la migration Evermaps ; Liquid n'a pas de filtre pour le
   décoder côté serveur (parse_json n'existe pas dans ce Liquid). On complète
   donc le schema LocalBusiness côté client, à partir des mêmes données déjà
   utilisées pour la modale horaires. */
document.addEventListener('DOMContentLoaded', () => {
  const dataScript = document.querySelector('[id^="StoreHoursData-"]');
  const schemaScript = document.querySelector('script[data-schema="local-business"]');
  if (!dataScript || !schemaScript) return;
let hoursData;
  try {
    hoursData = JSON.parse(dataScript.textContent || '{}');
  } catch (e) {
    return;
  }

  const standard = hoursData.standard || {};
  const dayAbbr = {
    monday: 'Mo',
    tuesday: 'Tu',
    wednesday: 'We',
    thursday: 'Th',
    friday: 'Fr',
    saturday: 'Sa',
    sunday: 'Su'
  };

  const openingHours = [];
  Object.keys(dayAbbr).forEach((day) => {
    const ranges = standard[day] || [];
    ranges.forEach((range) => {
      const clean = String(range).replace(/\s+/g, '');
      if (clean) openingHours.push(`${dayAbbr[day]} ${clean}`);
    });
  });

  if (!openingHours.length) return;

  try {
    const schema = JSON.parse(schemaScript.textContent);
    schema.openingHours = openingHours;
    schemaScript.textContent = JSON.stringify(schema);
  } catch (e) {
    /* schema illisible, on laisse tel quel */
  }
});

